import * as React from "react";
import { Box, TextFieldProps } from "@mui/material";
import { TextField } from "./";
import { DateRangePicker as MaterialDateRangePicker, DateRangePickerProps as MaterialDateRangePickerProps } from "@mui/x-date-pickers-pro";
import { Moment } from "moment";

interface DateRangePickerProps extends Omit<MaterialDateRangePickerProps<Moment, Moment>, 'renderInput'> {
    renderInput?: (startProps: TextFieldProps, endProps: TextFieldProps) => React.ReactElement;
    startLabel?: string;
    endLabel?: string;
}

const DateRangePicker: React.FunctionComponent<DateRangePickerProps> = React.forwardRef((props: DateRangePickerProps, ref: any) => {
    const { startLabel, endLabel, ...rest } = props;

    return <MaterialDateRangePicker 
        ref={ref}
        inputFormat="DD/MM/yyyy"
        mask="__/__/____"
        renderInput={(startProps, endProps) => (
            <React.Fragment>
                <TextField size="small" {...startProps} label={startLabel} />
                <Box sx={{ mx: 2 }}> to </Box>
                <TextField size="small" {...endProps} label={endLabel} />
            </React.Fragment>
        )}
        {...rest}
    />;
});

export default DateRangePicker;